import { CredentialModel } from './credential.model';
import { CameraModel } from './camera.model';
import { UserModel } from './user.model';

export class SiteModel {
  Id: number;
  Name: string;
  CameraServerName: string;
  CredentialId: number;
  Domain: string;
  ServicePort: number;
  IsAcs: boolean;
  ServerVersion?: string;
  LastSync?: Date;
  IpAddress?: string;
  AcsId?: string;
  MobilePort?: number = 55757;

  Credential?: CredentialModel;
  Cameras: CameraModel[] = [];
  Users: UserModel[] = [];

  // for UI views
  IsSelected: boolean;
  HasError?: boolean;
  ErrorMessage: string;
}
